import pagesData, {
  SliderContent,
  StockContent,
  TemplateListContent
} from '@anm/data/video-templates/pages';

import { templateActions } from '../../../store/modules/template';
import { DispatchGetInitialProps } from '../dispatchCurrentTemplateNew';

import {
  fetchCalendar,
  fetchStocks,
  fetchTemplatesForSlider,
  fetchTemplatesList,
  fetchTemplateView,
  getPageNameOrTemplateIdFromProps,
  saveFilters,
  setPageNumber
} from './helpers';

const dispatchPageContent = ({ query, dispatch }: DispatchGetInitialProps) => {
  const pageNameOrTemplateIdFromProps = getPageNameOrTemplateIdFromProps(query);

  const pageData = pagesData[pageNameOrTemplateIdFromProps];
  const isNotPage = !pageData;

  if (isNotPage) {
    return fetchTemplateView({
      query,
      dispatch,
      templateIdOrSlug: pageNameOrTemplateIdFromProps
    });
  }

  saveFilters({ query, dispatch });
  setPageNumber({ query, dispatch });
  dispatch(templateActions.setTemplatesPageName(pageNameOrTemplateIdFromProps));

  pageData.content.forEach(item => {
    switch (true) {
      case item.type === 'slider': {
        const sliderItem = item as SliderContent;
        return fetchTemplatesForSlider({ query, dispatch, item: sliderItem });
      }
      case item.type === 'templates': {
        const templateItem = item as TemplateListContent;
        return fetchTemplatesList({ query, dispatch, item: templateItem });
      }
      case item.type === 'stocks': {
        const stockItem = item as StockContent;
        return fetchStocks({ query, dispatch, item: stockItem });
      }
      case item.type === 'calendar': {
        return fetchCalendar({ query, dispatch });
      }
    }
  });
};

export default dispatchPageContent;
